// Central device registry used by both HomePage and scheduling UI.
// Each area has a type ("light" | "curtain") and a commandMapping.
// Commands for curtains are placeholders — update zone keys and strings
// once the device documentation is available.

export const AREAS = [
  {
    src: "/image/cafe.png",
    title: "Cafe Area",
    type: "light",
    buttonNames: [
      "Floor Light",
      "Shelf Light",
      "Pantry Light",
      "Hanging Right Light",
      "Hanging Left Light",
      "Hanging Center Light",
      "master key",
    ],
    commandMapping: {
      "Floor Light": {
        on: { cafeteria: "floor_light_on" },
        off: { cafeteria: "floor_light_off" },
      },
      "Shelf Light": {
        on: { cafeteria: "shelf_light_on" },
        off: { cafeteria: "shelf_light_off" },
      },
      "Pantry Light": {
        on: { cafeteria: "pantary_light_on" },
        off: { cafeteria: "pantary_light_off" },
      },
      "Hanging Right Light": {
        on: { cafeteria: "hanging_right_light_on" },
        off: { cafeteria: "hanging_right_light_off" },
      },
      "Hanging Left Light": {
        on: { cafeteria: "hanging_left_light_on" },
        off: { cafeteria: "hanging_left_light_off" },
      },
      "Hanging Center Light": {
        on: { cafeteria: "hanging_center_light_on" },
        off: { cafeteria: "hanging_center_light_off" },
      },
      "master key": {
        on: [
          { cafeteria: "floor_light_on" },
          { cafeteria: "shelf_light_on" },
          { cafeteria: "pantary_light_on" },
          { cafeteria: "hanging_right_light_on" },
          { cafeteria: "hanging_left_light_on" },
          { cafeteria: "hanging_center_light_on" },
        ],
        off: [
          { cafeteria: "floor_light_off" },
          { cafeteria: "shelf_light_off" },
          { cafeteria: "pantary_light_off" },
          { cafeteria: "hanging_right_light_off" },
          { cafeteria: "hanging_left_light_off" },
          { cafeteria: "hanging_center_light_off" },
        ],
      },
    },
  },

  {
    src: "/image/staff.png",
    title: "Staff Area",
    type: "light",
    buttonNames: [
      "Left Light 1", "Left Light 2", "Left Light 3",
      "Center Light 1", "Center Light 2", "Center Light 3",
      "Right Light 1", "Right Light 2", "Right Light 3",
      "Right Light 4", "Right Light 5",
    ],
    commandMapping: {
      "Left Light 1":   { on: { staff_area: "left_light_1_on" },   off: { staff_area: "left_light_1_off" } },
      "Left Light 2":   { on: { staff_area: "left_light_2_on" },   off: { staff_area: "left_light_2_off" } },
      "Left Light 3":   { on: { staff_area: "left_light_3_on" },   off: { staff_area: "left_light_3_off" } },
      "Center Light 1": { on: { staff_area: "center_light_1_on" }, off: { staff_area: "center_light_1_off" } },
      "Center Light 2": { on: { staff_area: "center_light_2_on" }, off: { staff_area: "center_light_2_off" } },
      "Center Light 3": { on: { staff_area: "center_light_3_on" }, off: { staff_area: "center_light_3_off" } },
      "Right Light 1":  { on: { staff_area: "right_light_1_on" },  off: { staff_area: "right_light_1_off" } },
      "Right Light 2":  { on: { staff_area: "right_light_2_on" },  off: { staff_area: "right_light_2_off" } },
      "Right Light 3":  { on: { staff_area: "right_light_3_on" },  off: { staff_area: "right_light_3_off" } },
      "Right Light 4":  { on: { staff_area: "right_light_4_on" },  off: { staff_area: "right_light_4_off" } },
      "Right Light 5":  { on: { staff_area: "right_light_5_on" },  off: { staff_area: "right_light_5_off" } },
    },
  },

  {
    src: "/image/passage1.png",
    title: "Left Passage",
    type: "light",
    buttonNames: [
      "Left Passage Light 1", "Left Passage Light 2", "Left Passage Light 3",
      "Left Passage Light 4", "Left Passage Light 5", "Left Passage Light 6",
    ],
    commandMapping: {
      "Left Passage Light 1": { on: { walking_passage: "left_passage_light_1_on" }, off: { walking_passage: "left_passage_light_1_off" } },
      "Left Passage Light 2": { on: { walking_passage: "left_passage_light_2_on" }, off: { walking_passage: "left_passage_light_2_off" } },
      "Left Passage Light 3": { on: { walking_passage: "left_passage_light_3_on" }, off: { walking_passage: "left_passage_light_3_off" } },
      "Left Passage Light 4": { on: { walking_passage: "left_passage_light_4_on" }, off: { walking_passage: "left_passage_light_4_off" } },
      "Left Passage Light 5": { on: { walking_passage: "left_passage_light_5_on" }, off: { walking_passage: "left_passage_light_5_off" } },
      "Left Passage Light 6": { on: { walking_passage: "left_passage_light_6_on" }, off: { walking_passage: "left_passage_light_6_off" } },
    },
  },

  {
    src: "/image/passage2.png",
    title: "Right Passage",
    type: "light",
    buttonNames: [
      "Right Passage Light 1", "Right Passage Light 2", "Right Passage Light 3",
      "Right Passage Light 4", "Right Passage Light 5", "Right Passage Light 6",
      "Right Passage Light 7", "Right Passage Light 8",
    ],
    commandMapping: {
      "Right Passage Light 1": { on: { walking_passage: "right_passage_light_1_on" }, off: { walking_passage: "right_passage_light_1_off" } },
      "Right Passage Light 2": { on: { walking_passage: "right_passage_light_2_on" }, off: { walking_passage: "right_passage_light_2_off" } },
      "Right Passage Light 3": { on: { walking_passage: "right_passage_light_3_on" }, off: { walking_passage: "right_passage_light_3_off" } },
      "Right Passage Light 4": { on: { walking_passage: "right_passage_light_4_on" }, off: { walking_passage: "right_passage_light_4_off" } },
      "Right Passage Light 5": { on: { walking_passage: "right_passage_light_5_on" }, off: { walking_passage: "right_passage_light_5_off" } },
      "Right Passage Light 6": { on: { walking_passage: "right_passage_light_6_on" }, off: { walking_passage: "right_passage_light_6_off" } },
      // NOTE: commands for lights 7 & 8 were identical to light 6 in the original code — corrected here
      "Right Passage Light 7": { on: { walking_passage: "right_passage_light_7_on" }, off: { walking_passage: "right_passage_light_7_off" } },
      "Right Passage Light 8": { on: { walking_passage: "right_passage_light_8_on" }, off: { walking_passage: "right_passage_light_8_off" } },
    },
  },

  {
    src: "/image/manager.png",
    title: "Manager Area",
    type: "light",
    buttonNames: [
      "Manager Cabin 1 sitting", "Manager Cabin 1 window",
      "Manager Cabin 2 sitting", "Manager Cabin 2 window",
    ],
    commandMapping: {
      "Manager Cabin 1 sitting": { on: { manager_cabin_1: "sitting_spot_on" }, off: { manager_cabin_1: "sitting_spot_off" } },
      "Manager Cabin 1 window":  { on: { manager_cabin_1: "window_spot_on" },  off: { manager_cabin_1: "window_spot_off" } },
      "Manager Cabin 2 sitting": { on: { manager_cabin_2: "sitting_spot_on" }, off: { manager_cabin_2: "sitting_spot_off" } },
      "Manager Cabin 2 window":  { on: { manager_cabin_2: "window_spot_on" },  off: { manager_cabin_2: "window_spot_off" } },
    },
  },

  {
    src: "/image/1.png",
    title: "WorkStation Area",
    type: "light",
    buttonNames: ["Mini spot", "Passage Light", "Table Light"],
    commandMapping: {
      "Mini spot":      { on: { workstation_2: "mini_spot_on" },     off: { workstation_2: "mini_spot_off" } },
      "Passage Light":  { on: { workstation_2: "passage_light_on" }, off: { workstation_2: "passage_light_off" } },
      "Table Light":    { on: { workstation_2: "table_lights_on" },  off: { workstation_2: "table_lights_off" } },
    },
  },

  {
    src: "/image/2.png",
    title: "Meeting Area",
    type: "light",
    buttonNames: ["Left spot", "Right spot"],
    commandMapping: {
      "Left spot":  { on: { meeting_room: "left_spot_on" },  off: { meeting_room: "left_spot_off" } },
      "Right spot": { on: { meeting_room: "right_spot_on" }, off: { meeting_room: "right_spot_off" } },
    },
  },

  {
    src: "/image/manager.png",
    title: "Director Cabin 2",
    type: "light",
    buttonNames: ["Wall Light", "Entery Light", "Sitting spot"],
    commandMapping: {
      "Wall Light":   { on: { director_cabin_2: "wall_light_on" },  off: { director_cabin_2: "wall_light_off" } },
      "Entery Light": { on: { director_cabin_2: "entry_spot_on" },  off: { director_cabin_2: "entry_spot_off" } },
      "Sitting spot": { on: { director_cabin_2: "sitting_spot_on" }, off: { director_cabin_2: "sitting_spot_off" } },
    },
  },

  {
    src: "/image/manager.png",
    title: "Project Manager",
    type: "light",
    buttonNames: ["Front Spot", "Back Spot"],
    commandMapping: {
      "Front Spot": { on: { project_manager: "front_spot_on" }, off: { project_manager: "front_spot_off" } },
      "Back Spot":  { on: { project_manager: "back_spot_on" },  off: { project_manager: "back_spot_off" } },
    },
  },

  {
    src: "/image/manager.png",
    title: "Director Cabin 1",
    type: "light",
    buttonNames: [
      "Sitting spot 1", "Sitting spot 2", "Sitting spot 3",
      "Entrance spot 1", "Entrance spot 2", "Entrance spot 3",
      "Ceiling Light", "Spot Light",
      "Relax cave Light", "Relax Center Light", "Relax Entery Light",
      "Temple Light", "Hangging Light",
    ],
    commandMapping: {
      "Sitting spot 1":    { on: { director_cabin_1: "sitting_spot_1_on" },     off: { director_cabin_1: "sitting_spot_1_off" } },
      "Sitting spot 2":    { on: { director_cabin_1: "sitting_spot_2_on" },     off: { director_cabin_1: "sitting_spot_2_off" } },
      "Sitting spot 3":    { on: { director_cabin_1: "sitting_spot_3_on" },     off: { director_cabin_1: "sitting_spot_3_off" } },
      "Entrance spot 1":   { on: { director_cabin_1: "entrance_spot_1_on" },    off: { director_cabin_1: "entrance_spot_1_off" } },
      "Entrance spot 2":   { on: { director_cabin_1: "entrance_spot_2_on" },    off: { director_cabin_1: "entrance_spot_2_off" } },
      "Entrance spot 3":   { on: { director_cabin_1: "entrance_spot_3_on" },    off: { director_cabin_1: "entrance_spot_3_off" } },
      "Ceiling Light":     { on: { director_cabin_1: "ceiling_cove_on" },       off: { director_cabin_1: "ceiling_cove_off" } },
      "Spot Light":        { on: { director_cabin_1: "spot_light_on" },         off: { director_cabin_1: "spot_light_off" } },
      "Relax cave Light":  { on: { director_cabin_1: "relax_cave_on" },         off: { director_cabin_1: "relax_cave_off" } },
      "Relax Center Light":{ on: { director_cabin_1: "relax_center_spot_on" },  off: { director_cabin_1: "relax_center_spot_off" } },
      "Relax Entery Light":{ on: { director_cabin_1: "relax_entry_spot_on" },   off: { director_cabin_1: "relax_entry_spot_off" } },
      "Temple Light":      { on: { director_cabin_1: "temple_light_on" },       off: { director_cabin_1: "temple_light_off" } },
      "Hangging Light":    { on: { director_cabin_1: "hangging_light_on" },     off: { director_cabin_1: "hangging_light_off" } },
    },
  },

  {
    src: "/image/conference.png",
    title: "Conferance Area",
    type: "light",
    buttonNames: ["Front Spot"],
    commandMapping: {
      "Front Spot": { on: { conferance: "front_spot_on" }, off: { conferance: "front_spot_off" } },
    },
  },

  {
    src: "/image/passage4.png",
    title: "Hr desk Area",
    type: "light",
    buttonNames: ["Hr Spot 1", "Hr Spot 2", "Passage Light"],
    commandMapping: {
      "Hr Spot 1":    { on: { hr_desk: "hr_spot_light_1_on" }, off: { hr_desk: "hr_spot_light_1_off" } },
      "Hr Spot 2":    { on: { hr_desk: "hr_spot_light_2_on" }, off: { hr_desk: "hr_spot_light_2_off" } },
      "Passage Light":{ on: { hr_desk: "Passage_light_on" },   off: { hr_desk: "Passage_light_off" } },
    },
  },

  {
    src: "/image/recp.png",
    title: "Reception",
    type: "light",
    buttonNames: [
      "Hanging Light 1", "Hanging Light 2", "Hanging Light 3",
      "Main Passage Light 1", "Main Passage Light 2", "Main Passage Light 3",
      "Main Passage Light 4", "Main Passage Light 5", "Main Passage Light 6",
    ],
    commandMapping: {
      "Hanging Light 1":      { on: { reception: "hanging_light_1_on" },             off: { reception: "hanging_light_1_off" } },
      "Hanging Light 2":      { on: { reception: "hanging_light_2_on" },             off: { reception: "hanging_light_2_off" } },
      "Hanging Light 3":      { on: { reception: "hanging_light_3_on" },             off: { reception: "hanging_light_3_off" } },
      "Main Passage Light 1": { on: { reception: "main_lift_passage_light_1_on" },   off: { reception: "main_lift_passage_light_1_off" } },
      "Main Passage Light 2": { on: { reception: "main_lift_passage_light_2_on" },   off: { reception: "main_lift_passage_light_2_off" } },
      "Main Passage Light 3": { on: { reception: "main_lift_passage_light_3_on" },   off: { reception: "main_lift_passage_light_3_off" } },
      "Main Passage Light 4": { on: { reception: "main_lift_passage_light_4_on" },   off: { reception: "main_lift_passage_light_4_off" } },
      "Main Passage Light 5": { on: { reception: "main_lift_passage_light_5_on" },   off: { reception: "main_lift_passage_light_5_off" } },
      "Main Passage Light 6": { on: { reception: "main_lift_passage_light_6_on" },   off: { reception: "main_lift_passage_light_6_off" } },
    },
  },

  {
    src: "/image/recp.png",
    title: "Robot Lab",
    type: "light",
    buttonNames: ["Robot Light"],
    commandMapping: {
      "Robot Light": { on: { robot_lab: "robot_lab_light_on" }, off: { robot_lab: "robot_lab_light_off" } },
    },
  },

];

// Returns all zones referenced in an area's commandMapping
export function extractZones(commandMapping) {
  const zones = new Set();
  for (const cmd of Object.values(commandMapping)) {
    const actions = [cmd.on, cmd.off, cmd.open, cmd.close, cmd.stop].filter(Boolean);
    for (const action of actions) {
      const cmds = Array.isArray(action) ? action : [action];
      for (const c of cmds) {
        const key = Object.keys(c)[0];
        if (key) zones.add(key);
      }
    }
  }
  return [...zones];
}

// ─── Curtains (DIN-RE8 UDP controllers on port 4444) ─────────────────────────
// Relay 1 = Open direction, Relay 2 = Close direction.
// If a curtain opens when you press Close (or vice versa), swap ch:1 and ch:2.
// Command format tries JSON first — if not working, update data string below.

export const CURTAINS = [
  { name: 'Curtain 1', ip: '192.168.0.43', mac: 'GO_80646F10949F' },
  { name: 'Curtain 2', ip: '192.168.0.44', mac: 'GO_80646F1114FB' },
  { name: 'Curtain 3', ip: '192.168.0.45', mac: 'GO_80646F111573' },
  { name: 'Curtain 4', ip: '192.168.0.47', mac: 'GO_083A8D348D7B' },
  { name: 'Curtain 5', ip: '192.168.0.49', mac: 'GO_D4D4DA152FDB' },
  { name: 'Curtain 6', ip: '192.168.0.51', mac: 'GO_80646F1082EF' },
];

export function curtainCommand(ip, mac, action) {
  const cmds = {
    // JSON format — most common for Goyun/DIN-RE8 devices
    open:  JSON.stringify({ mac, ch: 1, act: 1 }),
    close: JSON.stringify({ mac, ch: 2, act: 1 }),
    stop:  JSON.stringify({ mac, ch: 1, act: 0 }),
  };
  return { _protocol: 'udp', host: ip, port: 4444, data: cmds[action] };
}

// Returns schedulable devices for an area (excludes array commands like master key)
export function getSchedulableDevices(area) {
  return area.buttonNames.filter((name) => {
    const cmd = area.commandMapping[name];
    if (!cmd) return false;
    const firstAction = Object.values(cmd)[0];
    return !Array.isArray(firstAction);
  });
}
